import { useEffect } from 'react';

import { useSetTeamsConfigActions } from '../../store/main';
import { type EmbedConfig } from '../../types';

export const useSetEmbedConfig = (embedConfig: EmbedConfig): void => {
	const { setEmbedConfig } = useSetTeamsConfigActions();

	useEffect(() => {
		setEmbedConfig(embedConfig);
	}, [setEmbedConfig, embedConfig]);
};
